import { render, staticRenderFns } from "./ConnectWalletButton.vue?vue&type=template&id=7bb836b0&scoped=true"
import script from "./ConnectWalletButton.vue?vue&type=script&lang=js"
export * from "./ConnectWalletButton.vue?vue&type=script&lang=js"
import style0 from "./ConnectWalletButton.vue?vue&type=style&index=0&id=7bb836b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb836b0",
  null
  
)

export default component.exports